import { FlvDemuxer } from 'xgplayer-helper-transmuxers'
import { FetchLoader } from 'xgplayer-helper-utils'
import { Tracks, Buffer as XgBuffer } from 'xgplayer-helper-models'

class Logger {
  warn () {}
}

export default {
  FlvDemuxer,
  FetchLoader,
  Tracks,
  XgBuffer,
  Logger
};
